import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'

import { routes as authRoutes } from './auth'
import { routes as contentPageRoutes } from './content-pages'
import { routes as profileRoutes } from './profile'
import { routes as advertRoutes } from './adverts'
import { routes as bidCardRoutes } from './bid-cards'
import { routes as bidSessionRoutes } from './bid-sessions'
import { routes as adWatchRoutes } from './ad-watches'
import { routes as ongoingBidsRoutes } from './ongoing-bids'
import { routes as arenaRoutes } from './arena'
import { routes as ratingRoutes } from './ratings'
import { routes as statRoutes } from './stat'
import { routes as newsletterRoutes } from './newsletter'
import { routes as adminRoutes } from './admin'
import { routes as aboutRoutes } from './about'

import { maybeRedirectToProfile, requiresAdmin, requiresAuth, validateToken } from './guards/auth'
import { enforceView, requiresPrivacyPolicyConsent, requiresValidProfile } from './guards/profile'
import { trackPageView } from './guards/analytics'

export const createHeroView = id => () => import('../views/CreateHeroView').then(m => m.default(id))
export const createNavigationView = id => () => import('../views/CreateNavigationView').then(m => m.default(id))

const NotFound = () => import('../components/NotFound.vue')
const ManpowerSearchModal = () => import('../components/Modals/ManpowerSearchModal')
const JobSeekerModal = () => import('../components/Modals/JobSeekerModal')
const VideoModal = () => import('../components/Modals/VideoModal.vue')
const AuthRequiredModal = () => import('../components/Modals/AuthRequiredModal')
const AjkaModal = () => import('../components/Modals/AjkaModal.vue')
const BekescsabaModal = () => import('../components/Modals/BekescsabaModal.vue')

Vue.use(Router)

export function goToRedirectUrl ($router, $route) {
  let redirect = $route.query.redirect
  if (redirect) {
    $router.push(redirect)
    return true
  }

  return false
}

let routes = [
  {
    path: '*',
    components: {
      default: NotFound,
      hero: createHeroView(),
      navigation: createNavigationView()
    }
  },
  {
    path: '/',
    components: {
      default: Home,
      hero: createHeroView('home'),
      navigation: createNavigationView()
    },
    children: [
      {
        path: 'infografika/munkaado',
        component: ManpowerSearchModal
      },
      {
        path: 'infografika/munkakereso',
        component: JobSeekerModal
      },
      {
        path: 'video/:type',
        props: true,
        component: VideoModal
      },
      {
        path: 'bejelentkezes-szukseges',
        component: AuthRequiredModal
      },
      {
        path: 'ajka-devecser-es-tersege-ipartestulet',
        component: AjkaModal
      },
      {
        path: 'bekescsabai-ipartestulet',
        component: BekescsabaModal
      }
    ],
    meta: {
      pageTitle: 'Homepage'
    },
    beforeEnter: maybeRedirectToProfile
  },

  ...authRoutes(),
  ...contentPageRoutes(),
  ...profileRoutes(),
  ...advertRoutes(),
  ...bidSessionRoutes(),
  ...adWatchRoutes(),
  ...ongoingBidsRoutes(),
  ...arenaRoutes(),
  ...ratingRoutes(),
  ...statRoutes(),
  ...newsletterRoutes(),
  ...adminRoutes(),
  ...bidCardRoutes(),
  ...aboutRoutes()
]

export const router = new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      let x = 0
      let y = 0

      if (to.path.startsWith('/kisokos/')) {
        y = 220
      }

      return {
        selector: to.hash,
        offset: { x, y }
      }
    }

    if (to.meta.isModal || from.meta.isModal) {
      return
    }

    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes
})

router.beforeEach(trackPageView)
router.beforeEach(enforceView)
router.beforeEach(validateToken)
router.beforeEach(requiresAuth)
router.beforeEach(requiresAdmin)
router.beforeEach(requiresValidProfile)
router.beforeEach(requiresPrivacyPolicyConsent)



// WEBPACK FOOTER //
// ./src/router/index.js